<app-eca-modal-host [heading]="heading"
                    (editClicked)="removeOperativesClicked()"
                    editButtonColour="danger"
                    (closeClicked)="cancelClicked()"
                    (cancelClicked)="cancelClicked()"
                    [editButtonIcon]="['far', 'trash-alt']"
                    yesButtonText=""
                    yesButtonIcon=""
                    closeButtonText="Cancel"
                    editButtonText="Remove Operatives"
                    noButtonColour="transparent">
  <div class="container">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <p>Are you SURE you want to remove the selected Operatives?</p>
          <p>To continue, please enter the date that the operatives will no longer be engaged with your company.</p>
          <app-eca-date-picker [dateValue]="endDateForOperatives" [controlId]="'ctrlEndDateForOperatives'"
                               label="Date Ended"
                               [isValid]="!submitted || !!endDateForOperatives.dateTime"
                               validationMessage="Is Required"
                               [isRequired]="true"
                               popoverText="Please enter the date that operatives are no longer engaged with your company.">
          </app-eca-date-picker>
        </div>
      </div>
    </div>
  </div>
</app-eca-modal-host>
